import { ArrowRight } from "lucide-react";
import GlowButton from "../ui-custom/GlowButton";
import { Reveal } from "../ui-custom/Reveal";
import { useData } from "../../hooks/useData";

// Final call-to-action band.
export default function CTA() {
  const { data: links } = useData("links");
  return (
    <Reveal className="mx-auto max-w-7xl px-5 py-16" data-testid="cta-band">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-brand-gradient p-10 text-center text-white sm:p-16">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, white, transparent 40%)" }} />
        <h2 className="relative text-3xl font-bold sm:text-4xl lg:text-5xl">
          Ready to build your digital counter?
        </h2>
        <p className="relative mx-auto mt-4 max-w-xl text-white/85">
          Join 5000+ retailers growing their business. Get started in minutes.
        </p>
        <div className="relative mt-8 flex flex-wrap justify-center gap-4">
          <GlowButton href={links?.register} to={!links ? "/contact" : undefined} variant="ghost" className="!text-slate-900" icon={<ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />} data-testid="cta-start">
            Start Now
          </GlowButton>
          <GlowButton to="/pricing" variant="ghost" className="!text-slate-900" data-testid="cta-pricing">View Pricing</GlowButton>
        </div>
      </div>
    </Reveal>
  );
}
